export default __webpack_public_path__ + "static/media/lisieux12.8165b2fa.jpg";